<template>
    <div>
        <portal to="additional-action">
            <span
                v-if="widgetList.length"
                class="mr-2"
            >
                <el-button
                    @click="addAllWidgets"
                    type="_primary"
                    class="button-add-all"
                >
                    <div class="flex items-center">
                        <IconAdd :class="$rtl.isRTL ? 'ml-1' : 'mr-1'"/>
                        <span
                            class="text-base"
                        >
                            {{ $t('widget.addAll') }}
                        </span>
                    </div>
                </el-button>
            </span>
        </portal>
        <div class="search">
            <div class="w-full flex justify-center py-4">
                <div class="w-full max-w-md">
                    <el-input
                        v-model="search"
                        :disabled="!widgetList.length"
                        :placeholder="$t('general.search')"
                        class="input-search"
                    >
                        <template v-slot:prefix>
                            <i class="el-input__icon vc-icon-search text-primary text-xl" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="widget-cards flex flex-col -mx-4-5">
            <div
                v-for="(widget, index) in searchedWidgets"
                :key="index"
                class="w-full"
            >
                <WidgetCard
                    class="w-full"
                    :widget="widget"
                    v-on="$listeners"
                    @select-widget="selectWidget"
                    ref="widget-card"
                >
                    <template v-slot:template-preview>
                        <el-tooltip
                            :content="$t('widget.templateDictionary')"
                            :open-delay="openDelay"
                            class="item"
                            effect="dark"
                            placement="top"
                        >
                            <div class="flex items-center">
                                <i
                                    class="vc-icon-info text-primary text-xl mx-2"
                                    @click="onWidgetHelp(widget)"
                                />
                                <div class="break-normal text-primary">{{ $t('general.help') }}</div>
                            </div>
                        </el-tooltip>
                    </template>
                </WidgetCard>
            </div>
        </div>
    </div>
</template>

<script>
import { InputNumber, Tooltip } from 'element-ui'
import WidgetCard from "@/components/Reports/Widgets/AddWidgetsForm/WidgetCard";

export default {
    components: {
        WidgetCard,
        [Tooltip.name]: Tooltip,
        [InputNumber.name]: InputNumber,
    },
    props: {
        widgetList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            search: '',
            openDelay: 200
        }
    },
    computed: {
        searchedWidgets () {
            if (!this.search) {
                return this.widgetList
            }
            return this.widgetList.filter(widget => {
                return (this.translateTemplateNameContentTag(widget) && this.translateTemplateNameContentTag(widget).toLowerCase().includes(this.search.toLowerCase())) ||
                    (widget.DashboardTitle && widget.DashboardTitle.toLowerCase().includes(this.search.toLowerCase())) || 
                    (widget.WidgetGroupTitle && widget.WidgetGroupTitle.toLowerCase().includes(this.search.toLowerCase()))
            })
        },
    },
    methods: {
        addAllWidgets () {
            this.$emit('add-all-widgets-from-group')
        },
        onWidgetHelp (widget) {
            // some functionality
        },
        selectWidget (data) {
            this.$emit('selectedWidgets', data)
        },
        translateTemplateNameContentTag(widget) {
            return this.$te(widget.TemplateNameContentTag) ? this.$t(widget.TemplateNameContentTag) : widget.WidgetTitle
        }
    }
}
</script>

<style lang="scss" scoped>
.button-add-all {
    @apply px-4 py-0.5;
}
.widget-cards {
    max-height: 405px;
    overflow-y: auto;
}
</style>